<template>
  <el-form label-width="120px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="手机号" required>
      <el-input v-model="form.phone" disabled />
    </el-form-item>
    <el-form-item label="会员卡" required>
      <el-select v-model="form.goods_id" placeholder="" clearable>
        <el-option v-for="item in vipCards" :label="item.title" :value="item.id" />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
  import vipCardHook from '@/hooks/vipCardHook'
  import { onMounted, reactive } from 'vue'

  const props = defineProps(['item'])

  const form = reactive({
    phone: '',
    goods_id: '',
  })

  onMounted(() => {
    form.phone = props.item.phone
  })

  const { vipCards } = vipCardHook()

  defineExpose({ form })
</script>

<style lang="less" scoped>
  .demo-form-inline .el-input {
    --el-input-width: 220px;
  }

  .demo-form-inline .el-select {
    --el-select-width: 220px;
  }
  .form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
  }
</style>
